/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import clsx from 'clsx';
import { Tooltip } from '@marriott/mi-ui-library-shop';

export const MandatoryFeeTooltipIcon: React.FC<{
  HQVRateBlockFlag?: boolean;
  toolTipList?: any;
  handleTooltipClick?: (e: React.MouseEvent | React.KeyboardEvent) => void;
  isMapViewEnabled?: boolean;
  currentViewIsMobile?: boolean;
  currentViewIsTab?: boolean;
  clickTrackingLoc: string;
  tooltipSubheading: string;
}> = ({
  HQVRateBlockFlag,
  toolTipList,
  handleTooltipClick,
  isMapViewEnabled,
  currentViewIsMobile,
  currentViewIsTab,
  clickTrackingLoc,
  tooltipSubheading,
}) => (
  <span
    data-testid={'mandatory-fee-points-tooltip'}
    tabIndex={0}
    role="button"
    onKeyDown={(e): void => {
      if (e.key === 'Enter' || e.keyCode === 13) {
        e.preventDefault();
        handleTooltipClick?.(e);
      }
    }}
    aria-label={'Mandatory fee tooltip icon'}
    onClick={(e): void => {
      e.preventDefault();
      handleTooltipClick?.(e);
    }}
    className={clsx(
      !HQVRateBlockFlag ? 'icon-information' : '',
      't-font-xs',
      'point-savers-mandatory-fee-icon-map-view',
      !toolTipList?.length ? 'd-none' : '',
      isMapViewEnabled || currentViewIsMobile || currentViewIsTab ? 'points-mandatory-fee-icon-mobile-and-map' : ''
    )}
  >
    {HQVRateBlockFlag && (
      <Tooltip
        tooltipData={toolTipList}
        clickTrackingString={`${clickTrackingLoc}| Mandatory Fee Tooltip Button |internal`}
        tooltipParaText={tooltipSubheading}
        classForTooltipContainer={'d-inline'}
        customTabIdx={-1}
      />
    )}
  </span>
);
